const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    border: "0.05px solid rgba(99,115,164,0.2)",
    borderRadius: "4px",
    width: "270px",
    padding: "10px",
    paddingLeft: "10px",
    paddingBottom: "5px",
    paddingTop: "5px",
    boxSizing: "border-box",
    height: "auto",
    overflowY: "auto",
    overflowX: "hidden",
  },
  iconContainer: {
    display: "flex",
    paddingLeft: "10px",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: "10px",
    paddingBottom: "14px",
  },
  iconPosition: {
    marginLeft: "10px",
    marginRight: "15px",
  },
  stopContainer: {
    paddingBottom: "4px",
  },
  stop: {
    height: "4px",
    width: "4px",
    opacity: "0.5",
    backgroundColor: "#6373A4",
    borderRadius: "50%",
    position: "relative",
    left: "6px",
  },
  stopName: {
    width: "235px",
    color: "#085FE5",
    fontFamily: "CircularStd",
    fontSize: "14px",
    fontWeight: "500",
    paddingLeft: "35px",
    paddingBottom: "3px",
    position: "relative",
    top: "-1px",
  },
  trailIcon: {
    position: "relative",
    left: "-3px",
  },
  trailIconLowOpacity: {
    opacity: 0.4,
  },
  removeOpacity: {
    opacity: 1,
  },
  suggestionName: {
    transformOrigin: "0% 50%",
    width: "100%",
    color: "#6373A4",
    fontFamily: '"CircularStd"',
    fontSize: "14px",
    fontWeight: "300",
    letterSpacing: "0",
    paddingTop: "14px",
    paddingBottom: "14px",
    textAlign: "left",
    borderBottom: "1px solid rgba(99, 115, 164, 0.2)",
  },
  flexRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    height: "25px",
  },
  flexRowPaddingBottom: {
    paddingBottom: "12px",
  },
  flexRowPaddingTop: {
    paddingTop: "11px",
  },
  highlight: {
    color: "#085FE5",
  },
  noBottomBorder: {
    borderBottom: "none",
  },
  button: {
    boxSizing: "border-box",
    outline: 0,
    padding: 0,
    margin: 0,
    width: "100%",
    position: "relative",
    backgroundColor: "#ffffff",
    border: "none",
    cursor: "pointer",
    display: "block",
    marginBottom: "2px",
    "&:focus": {
      border: "solid rgb(8, 95, 229)",
    },
  },
  textAlignLeft: {
    textAlign: "left",
  },
  verticalAlignContainer: {
    display: "table", // Ugly, but works in IE11.  When IE11 is disposed, then use flex
  },
  dividerContainer: {
    height: "1px",
    justifyContent: "flex-end",
    display: "flex",
    width: "100%",
    "&:after": {
      content: "''",
      paddingRight: "15px",
    },
  },
  divider: {
    height: "1px",
    width: "195px",
    backgroundColor: "rgba(99, 115, 164, 0.2)",
  },
  dividerOpen: {
    height: "1px",
    width: "195px",
    backgroundColor: "rgba(99, 115, 164, 0.2)",
  },
  trailCount: {
    color: "#6373A4",
    fontFamily: "CircularStd",
    fontSize: "14px",
    fontWeight: 300,
    lineHeight: "22px",
    paddingLeft: "10px",
  },
  trailButton: {
    width: "100%",
  },
  mobileNextArrowButton: {
    width: "30%",
  },
  alignRight: {},
  alignLeft: {},
  leftTrailButtonWidth: {},
  rightTrailButtonWidth: {},
  verticalAlignWrapper: {
    display: "table", // Ugly, but works in IE11.  When IE11 is disposed, then use flex
  },
  verticalAlignChild: {
    display: "table-cell",
    textAlign: "center",
    verticalAlign: "middle",
  },
  alignSvgLeft: {
    justifyContent: "flex-start",
    display: "flex",
  },
  flexSuggestionRow: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
  },
  trailButtonHolder: {
    display: "flex",
    alignItems: "center",
  },
  mobileOnly: {
    display: "none",
    "@media screen and (max-width: 1200px)": {
      display: "block",
    },
  },
  arrowButton: {
    background: "transparent",
    outline: 0,
    border: 0,
  },
  // Portrait
  "@media screen and (max-width : 767px), (max-width : 1200px) and (orientation: portrait)": {
    container: {
      width: "inherit",
    },
    flexRow: {
      justifyContent: "unset",
    },
    suggestionName: {
      width: "100%",
      fontWeight: 500,
      paddingLeft: 5,
    },
    divider: {
      height: "1px",
      width: 300,
      opacity: 0.2,
      backgroundColor: "#6373A4",
    },
    dividerContainer: {
      paddingLeft: 30,
      "&:after": {
        content: "''",
        paddingRight: "39px",
      },
    },
    iconContainer: {
      paddingLeft: 29,
    },
    alignRight: { justifyContent: "flex-end", display: "flex", width: "40%" },
    alignLeft: { justifyContent: "flex-start", display: "flex", width: "100%" },
    leftTrailButtonWidth: {
      width: "65%",
    },
    rightTrailButtonWidth: {
      width: "35%",
    },
  },
  "@media screen and (max-width : 767px), (max-width : 1200px) and (orientation: landscape)": {
    container: {
      width: "inherit",
    },
    flexRow: {
      justifyContent: "unset",
    },
    suggestionName: {
      width: "100%",
      fontWeight: 500,
      paddingLeft: 5,
    },
    divider: {
      height: "1px",
      width: 300,
      opacity: 0.2,
      backgroundColor: "#6373A4",
    },
    dividerContainer: {
      paddingLeft: 30,
      "&:after": {
        content: "''",
        paddingRight: "39px",
      },
    },
    iconContainer: {
      paddingLeft: 29,
    },
    alignRight: { justifyContent: "flex-end", display: "flex", width: "40%" },
    alignLeft: { justifyContent: "flex-start", display: "flex", width: "100%" },
    leftTrailButtonWidth: {
      width: "65%",
      textAlign: "left",
    },
    rightTrailButtonWidth: {
      width: "35%",
    },
  },
};

export default styles;
